import { render, staticRenderFns } from "./Inspection.vue?vue&type=template&id=36dba70c"
import script from "./Inspection.vue?vue&type=script&lang=js"
export * from "./Inspection.vue?vue&type=script&lang=js"
import style0 from "./Inspection.vue?vue&type=style&index=0&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports